import { FC, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import {
  Stack,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from '@mui/material';
import { Logout, ViewList } from '@mui/icons-material';

import { AuthContext } from '@modules/Auth/contexts';
import { LAST_PROGRAM_SLUG_KEY } from '../views/ProgramLinkLanding';


export const ProgramHeader: FC = () => {
  const { user, isLoggedIn, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleLogout = useCallback(async () => {
    setAnchorEl(null);
    const lastSlug = sessionStorage.getItem(LAST_PROGRAM_SLUG_KEY);
    await logout();
    sessionStorage.removeItem(LAST_PROGRAM_SLUG_KEY);
    sessionStorage.removeItem('stc_return_url');
    if (lastSlug) {
      navigate(`/programs/${lastSlug}`, { replace: true });
    } else {
      navigate('/programs', { replace: true });
    }
  }, [logout, navigate]);

  const handleViewPrograms = useCallback(() => {
    setAnchorEl(null);
    navigate('/programs');
  }, [navigate]);

  if (!isLoggedIn) return null;

  const initials = user
    ? `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.toUpperCase()
    : '';

  return (
    <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1 }}>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} size="small">
        <Avatar
          src={user?.profilePicture || undefined}
          sx={{
            width: 36,
            height: 36,
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            fontSize: '0.875rem',
            fontFamily: '"Inter", sans-serif',
          }}
        >
          {initials}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {user && (
          <MenuItem disabled>
            <ListItemText
              primary={<Typography fontWeight={600}>{user.firstName} {user.lastName}</Typography>}
              secondary={user.email}
            />
          </MenuItem>
        )}
        <Divider/>
        <MenuItem onClick={handleViewPrograms}>
          <ListItemIcon><ViewList fontSize="small"/></ListItemIcon>
          <ListItemText>My Programs</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon><Logout fontSize="small"/></ListItemIcon>
          <ListItemText>Log Out</ListItemText>
        </MenuItem>
      </Menu>
    </Stack>
  );
};
